module.exports = __webpack_public_path__ + "img/10.c32f4e3d.png";